import * as React from "react";
import { forwardRef } from "react";
const SvgAiAnswer = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2.5L14.284 9.71605L21.5 12L14.284 14.284L12 21.5L9.71605 14.284L2.5 12L9.71605 9.71605L12 2.5Z", stroke: "#2C2D32", strokeWidth: 1.54054, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgAiAnswer);
export default ForwardRef;
